import { BrowserModule } from '@angular/platform-browser';
import { NgModule, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EngineerComponent } from './pages/administration/engineers/engineers.component';
import { EngineersManageComponent } from './pages/administration/engineers/engineers-manage/engineers-manage.component';
import { HttpClientModule } from '@angular/common/http';
import { AccountService } from './services/account.service';
import { AccountPickerComponent } from './components/pickers/account-picker/account-picker.component';
import { CustomerPickerComponent } from './components/pickers/customer-picker/customer-picker.component';
import { CompanyPickerComponent } from './components/pickers/company-picker/company-picker.component';
import { CustomerService } from './services/customer.service';
import { AuthService } from './services/auth.service';
import { LoginComponent } from './pages/login/login.component';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { AssetRegisterComponent } from './pages/reports/asset-register/asset-register.component';
import { JobReportComponent } from './pages/reports/job-reports/job-reports.component';
import { ROTEReportsComponent } from './pages/reports/rote/rote-reports.component';
import { ReportableService } from './services/reportable.service';
import { WebusersComponent } from './pages/administration/webusers/webusers.component';
import { WebusersManageComponent } from './pages/administration/webusers/webusers-manage/webusers-manage.component';
import { WebUserService } from './services/webuser.service';
import { EngineerService } from './services/engineer.service';
import { UserProfilePickerComponent } from './components/pickers/user-profile-picker/user-profile-picker.component';
import {DialogModule} from 'primeng/dialog';
import { BasketComponent } from './components/basket/basket.component';
import { CompanyService } from './services/company.service';
import { AssetManagementComponent } from './pages/administration/asset-management/asset-management.component';
import { LocationService } from './services/location.service';
import { CategoryService } from './services/category.service';
import { EquipmentService } from './services/equipment.service';
import { InspectionService } from './services/inspection.service';
import { FilterService } from './services/filter.service';
import { CookieService } from 'ngx-cookie-service';
import { LocationPickerComponent } from './components/pickers/location-picker/location-picker.component';
import { CategoryPickerComponent } from './components/pickers/category-picker/category-picker.component';
import { AssetManageComponent } from './pages/administration/asset-management/asset-manage/asset-manage.component';
import { DescriptionPickerComponent } from './components/pickers/description-picker/description-picker.component';
import { ReportTypeService } from './services/reporttype.service';
import { ReportTypePickerComponent } from './components/pickers/report-type-picker/report-type-picker.component';
import { LoadingIconComponent } from './components/components/loading-icon/loading-icon.component';
import { JobManagementComponent } from './pages/administration/job-management/job-management.component';
import { JobManageComponent } from './pages/administration/job-management/job-manage/job-manage.component';
import { JobService } from './services/job.service';
import { TechnicianPickerComponent } from './components/pickers/technician-picker/technician-picker.component';
import { TechnicianService } from './services/technician.service';
import { CalendarModule } from 'primeng/calendar';

@NgModule({
  declarations: [
    //PAGES
    AppComponent,
    DashboardComponent,
    EngineerComponent,
    EngineersManageComponent,
    LoginComponent,
    WebusersComponent,
    WebusersManageComponent,
    ROTEReportsComponent,
    AssetManagementComponent,
    AssetManageComponent,
    AssetRegisterComponent,
    JobReportComponent,
    JobManagementComponent,
    JobManageComponent,

    //PICKERS
    AccountPickerComponent,
    CustomerPickerComponent,
    CompanyPickerComponent,
    DescriptionPickerComponent,
    LocationPickerComponent,
    CategoryPickerComponent,
    UserProfilePickerComponent,
    ReportTypePickerComponent,
    TechnicianPickerComponent,


    BasketComponent,
    LoadingIconComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule,
    NgxDatatableModule,
    SnotifyModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,
    CalendarModule,
    ConfirmDialogModule,
    DialogModule
  ],
  providers: [
    AccountService,
    CustomerService,
    AuthService,
    SnotifyService,
    ConfirmationService,
    ReportableService,
    WebUserService,
    EngineerService,
    CompanyService,
    LocationService,
    CategoryService,
    ReportTypeService,
    EquipmentService,
    InspectionService,
    JobService,
    TechnicianService,
    FilterService,
    CookieService,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
